/** Copyright © 2013-2021 DataYes, All Rights Reserved. */

import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import moment from 'moment';
import zhCN from 'antd/lib/locale/zh_CN';
import 'moment/locale/zh-cn';
import { PageInterceptorProvider } from 'hooks/page-interceptor';
import AppRouter from './router';

moment.locale('zh-cn');

/**
 * StrictMode会让Antd的Form组件发生很奇怪的行为
 * 在Antd修复这个问题之前先禁用掉StrictMode
 * @see https://github.com/ant-design/ant-design/issues/27842
 */
ReactDOM.render(
  <ConfigProvider locale={zhCN}>
    <BrowserRouter>
      <PageInterceptorProvider>
        <AppRouter />
      </PageInterceptorProvider>
    </BrowserRouter>
  </ConfigProvider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
// serviceWorker.unregister();
